export const VETTING_MAX_FILE_TO_UPLOAD = 28
